export default {
  eyebrow: 'Kumppaniportaali',
  title: 'Palvelumaksulaskuri',
  description: 'Arvioi palvelumaksutulot kumppanitilisi alaisuudessa olevissa ravintoloissa.',
  toasts: {
    load_error: 'Palvelumaksuasetusten lataaminen epäonnistui.',
  },
};
